import { plugins } from 'common'

export const { i18n, validators, loadMessage } = plugins.createI18n()
